import React from 'react';

export default class Parallax extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.images = this.props.listing.heroImages;
    this.ref.current.listing = this.props.listing;
  }

  render() {
    return (
      <sh-parallax ref={this.ref}></sh-parallax>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/parallax.js